export function sttStatusLabel(status?: string, code?: string): string {
  switch (status) {
    case 'pending': return 'Transcription queued';
    case 'preparing': return 'Preparing audio';
    case 'submitting':
    case 'polling':
      if (code === 'provider_auth' || code === 'credentials_missing' || code === 'provider_configuration' || code === 'invalid_operation') return 'Transcription access needs operator attention';
      return code ? 'Transcription observation delayed; retrying' : 'Transcription in progress';
    case 'observation_paused': return 'Transcription observation paused; operator review required';
    case 'succeeded': return 'Transcription complete';
    case 'no_speech': return 'No speech detected';
    case 'quota_exceeded': return code === 'duration_limit' ? 'Recording exceeds transcription duration limit' : 'Transcription limit reached';
    case 'submission_unknown': return 'Transcription needs operator review';
    case 'failed': return 'Transcription failed';
    case 'disabled': return code === 'long_disabled' ? 'Long transcription is not enabled' : 'New transcription jobs are paused';
    default: return 'No transcript';
  }
}
